import { ImgCategoryType, ImgModeType } from '../../version-types/enum';

export const hasImageModeFeature = ({
    hint,
    mode,
    category,
}: {
    hint?: boolean;
    mode?: number;
    category?: ImgCategoryType;
}) => {
    return !!(
        hint ||
        mode === ImgModeType.matting ||
        mode === ImgModeType.mattingHead ||
        category === ImgCategoryType.qrCode ||
        category === ImgCategoryType.mainImg ||
        category === ImgCategoryType.subImg
    );
};
